// extracted by mini-css-extract-plugin
export default {"zr-table":"FulfillmentList_zr-table__0iU1K","table-header":"FulfillmentList_table-header__KhS68"};